__turbopack_context__.v({
  "blurBlob1": "Hero-module__ZARIfG__blurBlob1",
  "blurBlob2": "Hero-module__ZARIfG__blurBlob2",
  "btnPrimary": "Hero-module__ZARIfG__btnPrimary",
  "btnSecondary": "Hero-module__ZARIfG__btnSecondary",
  "checkIcon": "Hero-module__ZARIfG__checkIcon",
  "container": "Hero-module__ZARIfG__container",
  "content": "Hero-module__ZARIfG__content",
  "ctaGroup": "Hero-module__ZARIfG__ctaGroup",
  "description": "Hero-module__ZARIfG__description",
  "featureItem": "Hero-module__ZARIfG__featureItem",
  "featuresList": "Hero-module__ZARIfG__featuresList",
  "floatBlob": "Hero-module__ZARIfG__floatBlob",
  "hero": "Hero-module__ZARIfG__hero",
  "mockupImage": "Hero-module__ZARIfG__mockupImage",
  "playIconWrapper": "Hero-module__ZARIfG__playIconWrapper",
  "tag": "Hero-module__ZARIfG__tag",
  "title": "Hero-module__ZARIfG__title",
  "visual": "Hero-module__ZARIfG__visual",
});
